(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(scope) {
      (scope || document).querySelectorAll('[data-stlc-track]').forEach(function (track) {
        var root = track.closest('.stlc');
        if (!root) return;
        var cards = Array.prototype.slice.call(track.querySelectorAll('.stlc-card'));
        if (!cards.length) return;

        var prevBtns = Array.prototype.slice.call(root.querySelectorAll('[data-stlc-prev]'));
        var nextBtns = Array.prototype.slice.call(root.querySelectorAll('[data-stlc-next]'));
        var dotsBox = root.querySelector('[data-stlc-dots]');
        var fill = root.querySelector('[data-stlc-fill]');

        function step() {
          var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
          return cards[0].getBoundingClientRect().width + gap;
        }

        function perView() {
          var w = step();
          if (!w) return 1;
          return Math.max(1, Math.round(track.clientWidth / w));
        }

        function scrollToCard(i) {
          var card = cards[Math.max(0, Math.min(cards.length - 1, i))];
          if (!card) return;
          var cr = card.getBoundingClientRect();
          var tr = track.getBoundingClientRect();
          track.scrollTo({ left: track.scrollLeft + (cr.left - tr.left), behavior: 'smooth' });
        }

        var dots = [];
        var pages = 1;

        function rebuildDots() {
          if (!dotsBox) return;
          dotsBox.innerHTML = '';
          dots = [];
          pages = Math.max(1, Math.ceil(cards.length / perView()));
          for (var p = 0; p < pages; p++) {
            (function (idx) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'stlc-dot' + (idx === 0 ? ' is-active' : '');
              b.setAttribute('aria-label', '第 ' + (idx + 1) + ' 页');
              b.addEventListener('click', function () {
                scrollToCard(idx * perView());
              });
              dotsBox.appendChild(b);
              dots.push(b);
            })(p);
          }
        }
        rebuildDots();

        function currentPage() {
          var p = perView();
          var w = step();
          if (!w) return 0;
          return Math.min(pages - 1, Math.max(0, Math.round(track.scrollLeft / (w * p))));
        }

        function update() {
          var max = track.scrollWidth - track.clientWidth;
          var scrollable = max > 2;
          var atStart = track.scrollLeft <= 1;
          var atEnd = track.scrollLeft >= max - 1;

          prevBtns.concat(nextBtns).forEach(function (btn) {
            btn.classList.toggle('is-visible', scrollable);
          });
          prevBtns.forEach(function (b) { b.disabled = atStart; });
          nextBtns.forEach(function (b) { b.disabled = atEnd; });

          var cp = currentPage();
          dots.forEach(function (d, di) { d.classList.toggle('is-active', di === cp); });
          if (fill) fill.style.width = ((cp + 1) / pages) * 100 + '%';
        }

        function go(dir) {
          scrollToCard((currentPage() + dir) * perView());
        }

        prevBtns.forEach(function (b) {
          if (b.dataset.stlcBound) return;
          b.dataset.stlcBound = '1';
          b.addEventListener('click', function () { go(-1); });
        });
        nextBtns.forEach(function (b) {
          if (b.dataset.stlcBound) return;
          b.dataset.stlcBound = '1';
          b.addEventListener('click', function () { go(1); });
        });

        if (!track.dataset.stlcBound) {
          track.dataset.stlcBound = '1';
          track.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', function () {
            rebuildDots();
            update();
          });
        }
        update();
        window.addEventListener('load', function () { rebuildDots(); update(); });
      });
    }

    function initGallery(scope) {
      (scope || document).querySelectorAll('[data-stlc-gallery]').forEach(function (wrap) {
        var imgs = [];
        var alts = [];
        try { imgs = JSON.parse(wrap.getAttribute('data-imgs') || '[]'); } catch (e) { imgs = []; }
        try { alts = JSON.parse(wrap.getAttribute('data-alts') || '[]'); } catch (e) { alts = []; }

        var imgEl = wrap.querySelector('.stlc-img--primary') || wrap.querySelector('.stlc-img');
        var prev = wrap.querySelector('[data-stlc-img-prev]');
        var next = wrap.querySelector('[data-stlc-img-next]');
        var host = wrap.parentNode || wrap;
        var swatches = Array.prototype.slice.call(host.querySelectorAll('[data-stlc-swatch]'));

        if (!imgEl || imgs.length < 2) {
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }

        var idx = 0;

        function show(i) {
          idx = (i + imgs.length) % imgs.length;
          imgEl.setAttribute('src', imgs[idx]);
          if (imgEl.hasAttribute('srcset')) imgEl.removeAttribute('srcset');
          imgEl.setAttribute('alt', alts[idx] || '');
          swatches.forEach(function (sw, si) {
            sw.classList.toggle('is-current', si === idx);
          });
        }

        if (prev && !prev.dataset.stlcBound) {
          prev.dataset.stlcBound = '1';
          prev.hidden = false;
          prev.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            show(idx - 1);
          });
        }
        if (next && !next.dataset.stlcBound) {
          next.dataset.stlcBound = '1';
          next.hidden = false;
          next.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            show(idx + 1);
          });
        }

        swatches.forEach(function (sw, si) {
          if (sw.dataset.stlcSwBound) return;
          sw.dataset.stlcSwBound = '1';
          sw.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (si < imgs.length) show(si);
          });
        });

        show(0);
      });
    }

    function sampleColor(url, cb) {
      var img = new Image();
      var done = false;
      function finish(v) { if (done) return; done = true; cb(v); }
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var rgb = null;
        try {
          var w = 32, h = 32;
          var c = document.createElement('canvas');
          c.width = w; c.height = h;
          var ctx = c.getContext('2d');
          var nw = img.naturalWidth || img.width;
          var nh = img.naturalHeight || img.height;
          ctx.drawImage(img, nw * 0.3, nh * 0.3, nw * 0.4, nh * 0.4, 0, 0, w, h);
          var d = ctx.getImageData(0, 0, w, h).data;
          var r = 0, g = 0, b = 0, n = 0;
          for (var i = 0; i < d.length; i += 4) {
            if (d[i + 3] < 125) continue;
            var R = d[i], G = d[i + 1], B = d[i + 2];
            var mx = Math.max(R, G, B), mn = Math.min(R, G, B);
            if (mn > 235) continue;
            if (mx < 25) continue;
            r += R; g += G; b += B; n++;
          }
          if (n > 0) rgb = 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')';
        } catch (e) {}
        finish(rgb);
      };
      img.onerror = function () { finish(null); };
      img.src = url;
    }

    function paintSwatches(scope) {
      (scope || document).querySelectorAll('[data-stlc-swatch]').forEach(function (el) {
        if (el.dataset.stlcPainted === '1') return;
        el.dataset.stlcPainted = '1';
        var mode = el.dataset.mode || 'auto';
        var url = el.dataset.img;
        var hasBg = el.style.backgroundColor || el.style.backgroundImage;
        if (hasBg || !url || mode === 'image' || mode === 'color') return;
        sampleColor(url, function (rgb) {
          if (rgb) {
            el.style.backgroundColor = rgb;
          } else {
            el.classList.add('is-image');
            el.style.backgroundImage = 'url("' + url + '")';
          }
        });
      });
    }

    function setVW(scope) {
      (scope || document).querySelectorAll('[data-stlc]').forEach(function (el) {
        if (!el.classList.contains('stlc--full')) return;
        var w = document.documentElement.clientWidth;
        if (w) el.style.setProperty('--stlc-vw', w + 'px');
      });
    }

    var t;
    function boot() { initCarousel(); initGallery(); setVW(); paintSwatches(); }
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { setVW(); }, 100);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    function onSection(e) { initCarousel(e.target); initGallery(e.target); setVW(e.target); paintSwatches(e.target); }
    document.addEventListener('shopify:section:load', onSection);
    document.addEventListener('shopify:section:select', onSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-banner-full"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setViewportWidth(scope) {
      (scope || document).querySelectorAll('[data-stl2]').forEach(function (el) {
        if (!el.classList.contains('stl2--full')) return;
        var w = document.documentElement.clientWidth;
        if (w) el.style.setProperty('--stl2-vw', w + 'px');
      });
    }

    var t;
    function boot() { setViewportWidth(); }
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(boot, 100);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', function (e) { setViewportWidth(e.target); });
    document.addEventListener('shopify:section:select', function (e) { setViewportWidth(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
